import { render, staticRenderFns } from "./LecturaVentasInventarioView.vue?vue&type=template&id=2f12f952&scoped=true"
import script from "./LecturaVentasInventarioView.vue?vue&type=script&lang=js"
export * from "./LecturaVentasInventarioView.vue?vue&type=script&lang=js"
import style0 from "./LecturaVentasInventarioView.vue?vue&type=style&index=0&id=2f12f952&prod&lang=css"
import style1 from "./LecturaVentasInventarioView.vue?vue&type=style&index=1&id=2f12f952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12f952",
  null
  
)

export default component.exports